import type { PropsWithChildren } from 'react';
import React from 'react';
import { Manager, Popper, Reference } from 'react-popper';

import type { RewardsStateModel } from '@swf/core/types/RewardsLegacy';

import PanelDropDown from '../PanelDropDown/PanelDropDown';
import ProgressPanel from '../ProgressPanel/ProgressPanel';

import styles from './RewardsContainer.scss';

export interface Props {
  outsideClickIgnoreClass?: string;
  expanded?: boolean;
  rewards: RewardsStateModel;
  className?: string;
  dropDownVisible: boolean;
  clickOutside(): void;
  onMouseEnter(): void;
  onMouseLeave(): void;
  onClick(): void;
  onTouchStart(): void;
}

const RewardsContainer: React.FC<Props & PropsWithChildren> = ({
  outsideClickIgnoreClass,
  className,
  expanded,
  clickOutside,
  dropDownVisible,
  onMouseEnter,
  onMouseLeave,
  onTouchStart,
  rewards,
  onClick
}) =>
  expanded ? (
    <>
      <ProgressPanel
        rewards={rewards}
        className={className}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onTouchStart={onTouchStart}
        expanded={expanded}
        dropDownVisible={dropDownVisible}
      />
      <PanelDropDown
        data={rewards}
        clickOutside={clickOutside}
        outsideClickIgnoreClass={outsideClickIgnoreClass}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        expanded={expanded}
      />
    </>
  ) : (
    //  TODO: refactor with `usePopper`
    <Manager>
      <Reference>
        {({ ref }) => (
          <div ref={ref}>
            <ProgressPanel
              rewards={rewards}
              className={className}
              onClick={onClick}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
              onTouchStart={onTouchStart}
              expanded={expanded}
              dropDownVisible={dropDownVisible}
            />
          </div>
        )}
      </Reference>
      {dropDownVisible && (
        <Popper>
          {({ ref, style }) => (
            <div ref={ref} style={style} className={styles.popper}>
              <PanelDropDown
                data={rewards}
                clickOutside={clickOutside}
                outsideClickIgnoreClass={outsideClickIgnoreClass}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                expanded={expanded}
              />
            </div>
          )}
        </Popper>
      )}
    </Manager>
  );

export default RewardsContainer;
